import { ASSubpageEnum } from '../enums';
import { DataNode, SliderTiles } from '../utils/PickUpTypes';

export function dataNodesFromArray(config: DataNode[], array: string[]) {
    const result: DataNode[] = [];
    array.forEach(item => {
        const found = config.find(d => d.titel.toLowerCase() === item.toLowerCase());
        if (found) {
            result.push(found);
        }
    });
    return result;
}

export function stringArrayToSliderTileArray(config: DataNode[], array: string[]) {
    const result: SliderTiles[] = [];

    array.forEach(item => {
        const found = config.find(d => d.titel === item);
        if (found) {
            result.push({
                image: found.bild_url,
                title: found.titel,
                subline: found.secondline,
                onClick: ASSubpageEnum.Details,
                node: found,
            });
        }
    });
    return result;
}

export const experienceStringArray = ['Führungen', 'Werktour kompakt', 'Zeithaus'];
export const upgradesStringArray = ['Upgrade Festtag', 'Upgrade Autotürme']; //'Upgrade Fahrspaß', 'Upgrade Deluxe' zum 1.8. wieder in array rein
export const gastronomyStringArray = ['Lagune', 'Familienrestaurant AMano', 'Tachometer', 'Beef Club', 'Das Brot.', 'Erste Sahne'];
export const shopsStringArray = ['Volkswagen Zubehör Shop', 'moment!'];
export const ritzCarltonStringArray = ['Übernachten', 'Genießen', 'Abschalten', 'Durchatmen', 'Specials'];
export const toursStringArray = ['Autostadt rund um', 'Automobile Geschichten', 'Tour und Turm', 'Faszination Design'];
export const overnightStringArray = [''];
export const disconnectStringArray = ['Newman\'s Bar'];
export const breatheStringArray = ['Spa'];
export const specialsStringArray = ['Bleiben Sie länger', 'Erlebnismenü im Restaurant Terra', 'Cocktails & Snacks'];
export const enjoyStringArray= ['Terra', 'Lobby Lounge', 'Aura'];

export const experienceSliderStringArray = [
    'Virtual Racing',
    'Markenerlebnis Volkswagen',
    'Markenerlebnis VW R',
    'WORLD PROCESSOR - GLOBENFELD',
    'Ausstellung KI und Du',
    'Autostadt - kompakt',
    'Autostadt – Auf einen Blick'
];
